import {USP} from '@aboutyou/grpc-clients/tadarida/aysa_api/shared/v1/usp.types';
import {Link} from '@aboutyou/router';
import {COLORS, FONT_SIZES} from '@aboutyou/ui-components';
import {css} from '@linaria/core';
import {styled} from '@linaria/react';
import React from 'react';

const USP_ICON_SIZE = 24;

export const UspBannerItem: React.FC<USP> = ({href, image, label}) => {
  const trimmedLabel = label.replace(/\s/g, '');
  const dataTestId = `uspItem_${trimmedLabel}`;

  const content = (
    <>
      <Img
        data-testid={`UspIcon_${trimmedLabel}`}
        style={{
          backgroundImage: `url(${
            image.url + '&transparent=1&height=50&width=50'
          })`,
        }}
      />
      <StyledUspLabel data-testid={`UspText_${trimmedLabel}`}>
        {label}
      </StyledUspLabel>
    </>
  );

  if (!!href && href.length > 0) {
    return (
      <Link className={uspItemClassName} data-testid={dataTestId} to={href}>
        {content}
      </Link>
    );
  }

  return (
    <span className={uspItemClassName} data-testid={dataTestId}>
      {content}
    </span>
  );
};

const uspItemClassName = css`
  display: flex;
  align-items: center;
  padding: 0 10px;
`;

const Img = styled.div`
  width: ${USP_ICON_SIZE}px;
  height: ${USP_ICON_SIZE}px;
  background-size: ${USP_ICON_SIZE}px;
  filter: invert(1) opacity(1);
  margin-right: 10px;
`;

const StyledUspLabel = styled.span`
  font-size: ${FONT_SIZES.px10};
  color: ${COLORS.White};
  text-transform: uppercase;
  white-space: break-spaces;
  width: fit-content;
`;
